<div class="outer-container">
    <div class="img-container">
        <img src="./images/otp.svg">
    </div>
    <div class="data-container">
        <div>{{'verifyOtp.enterCode' | translate}}</div>
        <div><span class="link">{{displayEmail(modalData?.email)}}</span>&nbsp;{{'verifyOtp.or' | translate}}&nbsp;<span
                class="link">{{displayMobile(modalData?.mobileNumber)}}</span></div>
    </div>
    <form #ngForm (ngSubmit)="verifyOtp()">
        <div class="form-container">
            <ng-otp-input [config]="{length:4,allowNumbersOnly:true}" (onInputChange)="onOtpChange($event)">
            </ng-otp-input>
            <div class="display-b" *ngIf="!displayResendCode" [ngClass]="{'display-n': displayResendCode}">
                <p class="resend-txt">{{ 'verifyOtp.resend' | translate }}: <span id="time">02:00</span></p>
            </div>

            <div class="resend-txt-active cursor-pointer" *ngIf="displayResendCode" (click)="resendClick()">{{ 'verifyOtp.resend' | translate }}</div>
        </div>
        <div class="buttons-container">
            <button class="primary-button cursor-pointer" [disabled]="otp?.length < 4">{{
                'verifyOtp.verify' | translate
                }}</button>
            
        </div>
    </form>
    <button class="secondary-button cursor-pointer" (click)="cancelClick($event)">{{ 'verifyOtp.cancel' | translate
    }}</button>

</div>